"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var plot_1 = tslib_1.__importDefault(require("../base/plot"));
var util_1 = require("@antv/util");
var ComboPlot = /** @class */ (function (_super) {
    tslib_1.__extends(ComboPlot, _super);
    function ComboPlot() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ComboPlot.prototype.getDefaultOptions = function () {
        return {};
    };
    ComboPlot.prototype.getGlobalOptions = function (props) {
        return {
            xAxis: props.xAxis,
            yAxis: props.yAxis,
            theme: props.theme,
            legend: props.legend,
        };
    };
    ComboPlot.prototype.createComboLayers = function () {
        this.globalOptions = util_1.deepMix({}, this.getDefaultOptions(), this.getGlobalOptions(this.options));
    };
    return ComboPlot;
}(plot_1.default));
exports.default = ComboPlot;
//# sourceMappingURL=base.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/g2plot/lib/combo-plots/base.js
// module id = 842
// module chunks = 37